module.exports = __webpack_public_path__ + "img/rafael-lopez-aliaga.d409360a.png";